import { lazy, Suspense } from 'react';
import { Spinner } from '@comeon/ui';

// Util

export const preload = (...args: Promise<unknown>[]) => {
	Promise.all(args).catch(() => {});
};

// Load

export const loadTournamentsQueryClientProvider = () =>
	import(
		/* webpackChunkName: "tournaments-query-client-provider" */
		'./data/tournaments-query-client-provider'
	);

export const loadTournamentList = () =>
	import(
		/* webpackChunkName: "tournament-list" */
		'./tournament-list/tournament-list'
	);

export const loadTournamentDetails = () =>
	import(
		/* webpackChunkName: "tournament-details" */
		'./tournament-details/tournament-details'
	);

export const loadTournamentLobby = () =>
	import(
		/* webpackChunkName: "tournament-lobby" */
		'./tournament-lobby'
	);

export const loadTournamentDetailsLeaderboard = () =>
	import(
		/* webpackChunkName: "tournament-details-leaderboard" */
		'./tournament-details/tabs/tournament-details-leaderboard'
	);

export const loadTournamentDetailsGames = () =>
	import(
		/* webpackChunkName: "tournament-details-games" */
		'./tournament-details/tabs/tournament-details-games'
	);

export const loadTournamentDetailsRules = () =>
	import(
		/* webpackChunkName: "tournament-details-rules" */
		'./tournament-details/tabs/tournament-details-rules'
	);

export const loadTournamentResults = () =>
	import(
		/* webpackChunkName: "tournament-results" */
		'./tournament-results/tournament-results'
	);

export const loadEndedTournamentList = () =>
	import(
		/* webpackChunkName: "ended-tournament-list" */
		'./ended-tournament-list/ended-tournament-list'
	);

export const loadTournamentRankButton = () =>
	import(
		/* webpackChunkName: "tournament-rank-button" */
		'./tournament-rank-button/tournament-rank-button'
	);

export const loadTournamentRankDataPrefetcher = () =>
	import(
		/* webpackChunkName: "tournament-rank-button" */
		'./tournament-rank-button/tournament-rank-data-prefetcher'
	);

// Lazy Load

export const TournamentsQueryClientProvider = lazy(loadTournamentsQueryClientProvider);
export const TournamentList = lazy(loadTournamentList);
export const TournamentDetails = lazy(loadTournamentDetails);
export const TournamentLobby = lazy(loadTournamentLobby);
export const TournamentDetailsLeaderboard = lazy(loadTournamentDetailsLeaderboard);
export const TournamentDetailsGames = lazy(loadTournamentDetailsGames);
export const TournamentDetailsRules = lazy(loadTournamentDetailsRules);
export const TournamentResults = lazy(loadTournamentResults);
export const EndedTournamentList = lazy(loadEndedTournamentList);
export const TournamentRankButton = lazy(loadTournamentRankButton);
export const TournamentRankDataPrefetcher = lazy(loadTournamentRankDataPrefetcher);

// Compose

export const TournamentLobbyLoader = () => (
	<Suspense fallback={<Spinner />}>
		<TournamentLobby />
	</Suspense>
);

export const TournamentResultsLoader = () => (
	<Suspense fallback={<Spinner />}>
		<TournamentResults />
	</Suspense>
);

export const EndedTournamentListLoader = () => (
	<Suspense fallback={<Spinner />}>
		<EndedTournamentList />
	</Suspense>
);
